import { getConfig } from '../../../config';
import { ModalWrap } from '../../../components/modal-wrap';
import getFormatMessage from '../../../locales/get-format-message';
import { CommonSelect } from '../../../components/select';

export const SupportSwitchComponent = () => {
  const languageConfig = getConfig()?.languageConfig;
  const languageList = languageConfig?.languageList || [];

  const options = languageList?.[0].items.map((item) => {
    return {
      label: item.name,
      value: item.link,
    };
  });

  const showModal = (link: string) => {
    const matchedSite = options.find((item) => item.value === link);
    ModalWrap.show({
      title: '站点切换',
      children: `是否确认切换至${matchedSite?.label}站点?`,
      oKText: getFormatMessage('confirm'),
      cancelText: getFormatMessage('cancel'),
      async onOk() {
        window.location.href = link;
        return true;
      },
    });
  };

  return (
    <>
      <li>
        <CommonSelect
          value={
            options.find((item) => item.value.includes(location.host))?.value ||
            options[0]?.value
          }
          options={options}
          onChange={(val) => showModal(val)}
          dropdownMatchSelectWidth={false}
        />
      </li>
    </>
  );
};
